import api from './api';

export const authService = {
   register: async (userData) => {
      const response = await api.post('/users/register', userData);
      if (response.data.success && response.data.data.token) {
         if (typeof window !== 'undefined') {
            localStorage.setItem('token', response.data.data.token);
            localStorage.setItem('user', JSON.stringify(response.data.data.user));
         }
      }
      return response.data;
   },

   login: async (credentials) => {
      const response = await api.post('/users/login', credentials);
      if (response.data.success && response.data.data.token) {
         if (typeof window !== 'undefined') {
            localStorage.setItem('token', response.data.data.token);
            localStorage.setItem('user', JSON.stringify(response.data.data.user));
         }
      }
      return response.data;
   },

   logout: () => {
      if (typeof window !== 'undefined') {
         localStorage.removeItem('token');
         localStorage.removeItem('user');
      }
   },

   getCurrentUser: async () => {
      const response = await api.get('/users/me');
      return response.data;
   },

   isAuthenticated: () => {
      if (typeof window === 'undefined') return false;
      return !!localStorage.getItem('token');
   },

   getStoredUser: () => {
      if (typeof window === 'undefined') return null;
      const user = localStorage.getItem('user');
      return user ? JSON.parse(user) : null;
   },

   updateProfile: async (userData) => {
      const response = await api.put('/users/me', userData);
      if (response.data.success && typeof window !== 'undefined') {
         localStorage.setItem('user', JSON.stringify(response.data.data));
      }
      return response.data;
   },
};
